/* eslint-disable max-len */
import { Dispatch } from 'redux';
import { IPayStub } from 'src/interfaces';
import paymentsService from 'src/services/payments.service';

import { PaymentsActionType } from '../action-types';
import { PaymentsAction } from '../actions';

export const getPayments = (initialDate: string, finalDate: string) => async (dispatch: Dispatch<PaymentsAction>) => {
  dispatch({
    type: PaymentsActionType.GET_PAYMENTS,
  });

  try {
    const { data }: { data: IPayStub[] } = await paymentsService.getPayStubs(initialDate, finalDate);

    if (data.length) {
      dispatch({
        type: PaymentsActionType.GET_PAYMENTS_SUCCESS,
        payload: { payments: data },
      });
    } else {
      dispatch({
        type: PaymentsActionType.GET_PAYMENTS_FAILURE,
        payload: 'No content',
      });
    }
  } catch (err: any) {
    dispatch({
      type: PaymentsActionType.GET_PAYMENTS_FAILURE,
      payload: err.message,
    });
  }
};
